export const REQUEST_DELETE_LEARNING_AREA = "request_delete_learning_area"
export const DELETE_LEARNING_AREA_SUCCESS = "delete_learning_area_success"
export const DELETE_LEARNING_AREA_FAILURE = "delete_learning_area_failure"

export const CLEAR_DELETE_LEARNING_AREA = "clear_delete_learning_area "